import React, { createContext, useContext, useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const Context = createContext({ resolved: 'light', setMode: () => {} });
export function ThemeSwitcher() {
    const { resolved, setMode } = useContext(Context);
    const dark = resolved === 'dark';
    const Icon = dark ? Sun : Moon;
    const label = dark ? 'Включить светлую тему' : 'Включить тёмную тему';
    return <button type="button" className="theme-switcher" aria-label={label} title={label} onClick={() => setMode(dark ? 'light' : 'dark')}><Icon size={18} aria-hidden="true" /></button>;
}
export default function ThemeProvider({ children }) {
    const [mode, setMode] = useState(() => {
        try { const stored = localStorage.getItem('auth-theme'); return ['light', 'dark', 'system'].includes(stored) ? stored : 'system'; } catch (_) { return 'system'; }
    });
    const [systemDark, setSystemDark] = useState(() => window.matchMedia?.('(prefers-color-scheme: dark)').matches || false);
    const resolved = mode === 'system' ? systemDark ? 'dark' : 'light' : mode;
    useEffect(() => {
        const media = window.matchMedia?.('(prefers-color-scheme: dark)');
        const update = () => setSystemDark(media?.matches || false);
        media?.addEventListener('change', update);
        return () => media?.removeEventListener('change', update);
    }, []);
    useEffect(() => {
        document.documentElement.dataset.theme = resolved;
        try { localStorage.setItem('auth-theme', mode); } catch (_) {}
    }, [mode, resolved]);
    return <Context.Provider value={{ resolved, setMode }}>{children}</Context.Provider>;
}
